<template>
  <div class="add-refer-link-container">
    <div
      class="add-refer-link pointer"
      :class="{
        [`add-refer-link--${createRenderType}`]: true,
      }"
      @click="doAddReferenceLink"
    >
      <i class="block"></i>
      <span class="block">{{ $$t("create.song_link") }}</span>
      <label
        class="vip_plan"
        v-if="userDataStore.userInfo?.user?.vip_level_name != 'pro'"
      >
        {{ $$t("create.pro_plan") }}
      </label>
    </div>
    <div
      class="add-music-reference-edit-mask pointer"
      @click="
        (e) => {
          showSubscribeDialog()
          // goSubscribe(2, 'audioref_youtube_link');
        }
      "
      v-if="userDataStore.userInfo?.user?.vip_level_name != 'pro'"
    ></div>
    <AddLinkDialog
      v-model:visible="renderData.addLinkDialogVisible"
      @done="doAddReferenceLinkDone"
    />
    <EditReference
      :editFileName="renderData.editFileName"
      v-model:visible="renderData.editFilePopupVisible"
      v-if="renderData.editFilePopupVisible"
      :clipSourceData="renderData.clipSourceData"
      @complete="handleEditFileCompleted"
    >
    </EditReference>
  </div>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
} from "vue"

import { useRouter, useRoute } from "vue-router"
import globalConfig, { chinaAppName } from "@/config/config.js"

import AddLinkDialog from "./addLinkDialog.vue"
import EditReference from "./editReference.vue"

import tools from "@/utils/tools.js"

import apiReferMusic from "@/api/api/apiReferMusic.js"
import apiCommon from "@/api/api/apiCommon.js"
import userReferMusicStore from "@/store/create/referMusicStore.js"

import ffmpegUtil from "@/components/media/utils/ffmpegUtil.js"
import message from "@/components/functionCallComponent/message.jsx"
import clipUtil from "@/components/media/utils/clipUtil.js"
import objectStorage, {
  getObjectStorageFullUrl,
} from "@/lib/objectStorage/objectStorage.js"
import { validateYoutubeLink } from "@/utils/validationTools.js"
import axios from "axios"
import { storeToRefs } from "pinia"
import useCreateLayoutStore from "@/store/create/createLayoutStore.js"
import useUserDataStore from "@/store/userDataStore.js"
const createLayoutStore = useCreateLayoutStore()
const userDataStore = useUserDataStore()
const { createRenderType } = storeToRefs(createLayoutStore)
const Router = (getCurrentInstance() || window?.$getVueCurrentInstance?.())
  .appContext?.config?.globalProperties?.$router
const route = useRoute()
const { $$language, $$t, $$tm, $$tValue } = getCurrentInstance().appContext?.config.globalProperties.$i18n ?? {}

const props = defineProps({})
const emits = defineEmits(["showSubscribeDialog"])
const renderData = reactive({
  addLinkDialogVisible: false,
  linkParseUrl: "",
  file: null,
  linkUrl: "",
  editFilePopupVisible: false,
  clipSourceData: null,
  editFileName: "",
})

const goSubscribe = async (e, membership_source2) => {
  e ?? window.event?.stopPropagation()
  if (await userDataStore.checkLoginStatus()) {
    Router.push({
      name: "subscribe",
      query: {
        membership_source1: "membership_feature",
        membership_source2,
      },
    })
  }
}

const showSubscribeDialog = () => {
  emits("showSubscribeDialog", "reference", {
    membership_source1: "membership_feature",
    membership_source2: "audioref_youtube_link",
  })
}

const doAddReferenceLink = () => {
  renderData.addLinkDialogVisible = true
}

const doAddReferenceLinkDone = (url) => {
  renderData.linkUrl = url
  doSaveLink()
    .then((file) => {
      doInitEditFile(file, true)
    })
    .catch((e) => {
      console.error("doSaveLink error", e)
    })
}

const doDownloadFile = async (url, filename) => {
  return new Promise((resolve, reject) => {
    var xhr = new XMLHttpRequest()
    xhr.open("GET", url, true)
    xhr.responseType = "blob"
    xhr.onload = function (e) {
      if (this.status === 200) {
        var blob = new Blob([this.response], {
          type: this.response?.type || "text/plain",
        })
        const resfile = new File([blob], filename, { type: blob.type })
        resolve(resfile)
      } else {
        reject(this.statusText)
      }
    }
    xhr.send()
  })
}

const doSaveLink = async () => {
  return new Promise((resolve, reject) => {
    if (!validateYoutubeLink(renderData.linkUrl)) {
      message.error({
        position: "top",
        content: $$t("create.use_youtube"),
      })
      reject("invalid youtube link")
      return
    }
    const params = {
      url: renderData.linkUrl,
    }
    renderData.isLoading = true
    const closeMsg = message.loading({ content: $$t("create.parsing_link") })
    apiCommon
      .saveReferenceMusicTmp({
        url: renderData.linkUrl,
      })
      .then((res) => {
        if (res.code == 200) {
          if (
            (res.data?.duration_milliseconds ?? res.data?.duration ?? 0) <
            1000 * 10
          ) {
            message.info({
              position: "top",
              content: $$tValue("create.min_file_duration", { duration: 10 }),
            })
            reject("min file duration")
          } else {
            renderData.editFileName = (res.data?.name ?? "")?.slice(0, 60)
            doDownloadFile(
              getObjectStorageFullUrl(res.data?.cos_url),
              (res.data?.name ?? "audio_from_youtue").replace(/\s+/, "_") +
                "." +
                tools.getFileExtension(res.data?.cos_url ?? ".mp3")
            )
              .then((linkFile) => {
                closeMsg?.clear()
                // renderData.file = linkFile;
                renderData.linkParseUrl = getObjectStorageFullUrl(
                  res.data?.cos_url
                )
                resolve(linkFile)
              })
              .catch((e) => {
                closeMsg?.clear()
                reject(e)
              })
          }
        } else {
          closeMsg?.clear()
          if (
            res.code == 6116 ||
            (res.data?.duration_milliseconds ?? res.data?.duration ?? 0) ==
              7 * 1000 * 60
          ) {
            renderData.linkUrl = ""
            message.error({
              position: "top",
              content: $$t("create.style_link_max_duration"),
            })
          } else if (res.code == 1112) {
            message.error({
              position: "top",
              content: $$t("create.cur_position"),
            })
          } else {
            message.error({
              position: "top",
              content: $$t("create.invalid_link"),
            })
          }
          reject("invalid spider link")
        }
      })
      .catch((e) => {
        closeMsg?.clear()
        message.error({
          position: "top",
          content: $$t("create.invalid_link"),
        })
        reject(e)
      })
  })
}

const doInitEditFile = async (filep, isLink) => {
  let file = renderData.file ?? filep
  console.log("doInitEditFile", file.type, file)
  window.curSelectFile = file
  const closeMsg = message.loading({
    content: isLink ? $$t("create.parsing_link") : $$t("create.extract_song"),
  })
  let decodeData = null
  let blobUrl = null
  let duration = 0
  try {
    decodeData = await clipUtil.getDecodeDataByFile(file)
    duration = decodeData.duration
    blobUrl = (window.URL || window.webkitURL).createObjectURL(file)
  } catch (e) {
    try {
      console.log("name:", file.name, "type:", file.type, "size:", file.size)
      const outputfile = await ffmpegUtil.transFileToMp3(file)
      file = outputfile.file
      blobUrl = outputfile.blobUrl
      decodeData = await clipUtil.getDecodeDataByFile(file)
      duration = decodeData.duration
    } catch (e) {
      console.error("handleAfterReaderr", e)
      closeMsg.clear()
      message.info({
        content: $$t("create.extract_song_failed"),
      })
      return
    }
  }
  renderData.fileTemp = file

  console.log("renderEditFile", renderData.clipSourceData)
  closeMsg.clear()
  renderData.editFilePopupVisible = true
  nextTick().then(() => {
    renderData.clipSourceData = {
      duration: duration,
      isUpload: true,
      blobUrl: blobUrl,
      url: renderData.linkParseUrl,
      type: "audio/wav",
      decodeData,
    }
  })
}
const handleEditFileCompleted = async (fileData, close) => {
  const { getClipedExportData, data } = fileData
  const closeMsg = message.loading({
    position: "center",
    content: $$t("create.saving"),
  })
  let saveData = null
  try {
    let clipedExportData = await getClipedExportData()
    if (clipedExportData.blob.type != "audio/mp3") {
      try {
        let transfile = await ffmpegUtil.transFileToMp3(
          new File([clipedExportData.blob], "output.wav", { type: "audio/wav" })
        )
        clipedExportData.url = transfile.blobUrl
        clipedExportData.blob = transfile.blob
        clipedExportData.file = transfile.file
      } catch (e) {
        console.error("transFileToMp3 error", e)
      }
    }
    const fileSaveData = {
      url: clipedExportData.url,
      filename: data.filename,
      mood: data.moodTag?.value,
      genre: data.styleTag?.value,
      duration: clipedExportData.duration,
    }

    const objectStorageRes = await objectStorage.uploadFileToObjectStorage(
      clipedExportData.file,
      (obj) => {
        renderData.uploadCallbackData = obj
      }
    )
    saveData = {
      url: objectStorageRes.pathKey,
      duration_milliseconds: Math.ceil(fileSaveData.duration * 1000),
      upload_link: null,
      // feed_id: draftDataStore.feed_id,
      title: fileSaveData.filename,
      source_type: 1,
      mood: fileSaveData.mood,
      genre: fileSaveData.genre,
      resource: renderData.linkUrl,
    }
  } catch (e) {
    closeMsg.clear()
    console.error("uploadFileToObjectStorage error", e)
    message.error({
      position: "top",
      content: $$t("create.save_failed"),
    })
    return
  }

  apiReferMusic
    .addReferenceMusic(saveData)
    .then((res) => {
      closeMsg?.clear()
      if (res.code == 200 && res.data) {
        renderData.linkUrl = ""
        renderData.file = null
        renderData.addLinkDialogVisible = false
        close()
        renderData.clipSourceData = null
        emits("saveSuccess", res.data, true)
      } else {
        if (res.code == 6352) {
          message.info({
            position: "top",
            content: $$t("create.generate_refer_audit_failed"),
          })
        } else if (res.code == 6320) {
          message.error({
            position: "top",
            content: $$t("create.song_cover_auditing_failed"),
          })
        } else if (res.code == 6316) {
          message.error({
            position: "top",
            content: $$t("create.song_title_audit_failed"),
          })
        } else {
          message.error({
            position: "top",
            content: $$t("create.save_failed"),
          })
        }
      }
    })
    .catch((err) => {
      closeMsg?.clear()
      console.error("addReferenceMusic error", err)
      message.error({
        position: "top",
        content: $$t("create.save_failed"),
      })
    })
}

onMounted(() => {})
</script>
<style lang="scss">
.add-refer-link-container {
  position: relative;
  .add-music-reference-edit-mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
.add-refer-link {
  height: 56px;
  border-radius: 12px;
  padding: 0 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(148, 173, 255, 0.1);
  i {
    height: 20px;
    width: 20px;
    min-width: 20px;
    background: url("@/assets/img/link-white-ico.png") no-repeat center;
    background-size: 100% 100%;
  }
  span {
    margin-left: 4px;
    font-family: HarmonyOS Sans SC;
    font-size: 14px;
    font-weight: normal;
    color: #ffffff;
  }
  label.vip_plan {
    min-width: max-content;
    height: 14px;
    border-radius: 2px;
    background: linear-gradient(110deg, #ffe08b 0%, #fff7d0 47%, #ffe08b 100%);
    padding: 0 3px;
    line-height: 14px;
    
    font-size: 8px;
    font-weight: 500;
    color: #3d2d00;
    margin: 0 0 0 8px;
  }
  &:hover {
    background: rgba(148, 173, 255, 0.2);
  }
  &.add-refer-link--mobile {
    padding: 0 6px;

    span {
      font-size: 12px;
    }
  }
}
</style>
